import { useEffect, useState } from 'react'
import { POLL_MS } from '../config/board'

// One clock for the whole board, ticking with the catalog poll: the program window
// is re-evaluated at the same rate as the data it switches between.
export function useNow(intervalMs: number = POLL_MS): Date {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), intervalMs)
    return () => window.clearInterval(id)
  }, [intervalMs])
  return now
}
